import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Heading,
} from "@chakra-ui/react";
import { useIsSaplingEnabled } from "@umami/state";

import { ShieldedActivityTab } from "./ShieldedActivityTab";

import { FiShieldIcon } from "@/assets/icons";
import { useColor } from "@/styles/useColor";

export const ShieldedTransactionsAccordion = () => {
  const isSaplingEnabled = useIsSaplingEnabled()();
  const color = useColor();

  if (!isSaplingEnabled) {
    return null;
  }

  return (
    <Accordion zIndex={1000} allowToggle defaultIndex={1}>
      <AccordionItem
        marginBottom="16px"
        borderWidth="0px"
        borderStyle="solid"
        borderColor={color("gray.50")}
        borderRadius="20px"
        backgroundColor={color("gray.50")}
      >
        <Heading>
          <AccordionButton padding="12px" borderRadius="20px" backgroundColor={color("gray.50")}>
            <Heading flex="1" color={color("900")} textAlign="left" size="md">
              <Flex alignItems="center" gap="10px">
                <FiShieldIcon width="24px" height="24px" />
                Shielded Transactions
              </Flex>
            </Heading>
            <AccordionIcon />
          </AccordionButton>
        </Heading>
        <AccordionPanel marginBottom="16px" padding="16px 0px">
          <ShieldedActivityTab />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
